module.exports = __webpack_public_path__ + "img/bg3.f7dfa797.png";